module.exports = __webpack_public_path__ + "img/paris-fc-logo-icon.aa7dba85.png";